import router from './router'

export default {
	moduleName: 'contentRecycleBin',
  router
}



// WEBPACK FOOTER //
// ./src/core/modules/contentRecycleBin/index.js